import React from 'react';
import { Layout, Typography, Divider, Card, Space, Button } from 'antd';
import { SafetyCertificateOutlined, LockOutlined, EyeOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import './style.css';

const { Content, Footer } = Layout;
const { Title, Paragraph, Text } = Typography;

const PoliticaPrivacidad = () => {
    const navigate = useNavigate();

    return (
        <Layout style={{ background: '#f0f2f5', minHeight: '100vh' }}>
            <Content style={{ padding: '50px 20px' }}>
                <Card
                    style={{
                        maxWidth: '900px',
                        margin: '0 auto',
                        borderRadius: '12px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                    }}
                >
                    <Button
                        type="link"
                        icon={<ArrowLeftOutlined />}
                        onClick={() => navigate(-1)}
                        style={{ color: '#22BABB', marginBottom: '20px', padding: 0 }}
                    >
                        Volver atrás
                    </Button>

                    <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                        <SafetyCertificateOutlined style={{ fontSize: '48px', color: '#22BABB' }} />
                        <Title level={1} style={{ marginTop: '10px', color: '#22BABB' }}>Política de Privacidad</Title>
                        <Text type="secondary">Última actualización: 15 de febrero de 2026</Text>
                    </div>

                    <Divider />

                    <Space direction="vertical" size="large" style={{ width: '100%' }}>
                        <section>
                            <Title level={4}><EyeOutlined /> 1. Información que Recolectamos</Title>
                            <Paragraph>
                                Para el funcionamiento de la plataforma <b>YUGONUB</b>, recolectamos:
                                <ul>
                                    <li><b>Datos del Usuario:</b> Nombre, NIT/Cédula, correo, teléfono y dirección (almacenados en AWS Cognito).</li>
                                    <li><b>Datos de Operación:</b> Información de ventas, inventarios y clientes finales cargados por el usuario.</li>
                                    <li><b>Datos Técnicos:</b> Dirección IP y cookies de sesión para garantizar la seguridad de la cuenta.</li>
                                </ul>
                            </Paragraph>
                        </section>

                        <section>
                            <Title level={4}><LockOutlined /> 2. Seguridad y Almacenamiento</Title>
                            <Paragraph>
                                La seguridad de su información es nuestra prioridad. Yugonub utiliza infraestructura de <b>Amazon Web Services (AWS)</b>,
                                lo que garantiza cifrado de datos en tránsito y en reposo. Las contraseñas son gestionadas mediante protocolos de hashing
                                avanzados, por lo que ningún miembro del equipo de Yugonub tiene acceso a su clave personal.
                            </Paragraph>
                        </section>

                        <section>
                            <Title level={4}>3. Uso de los Datos</Title>
                            <Paragraph>
                                Los datos recolectados se utilizan exclusivamente para:
                                <ul>
                                    <li>Gestionar el acceso a su panel administrativo.</li>
                                    <li>Personalizar los documentos generados por el sistema (facturas, reportes).</li>
                                    <li>Brindar soporte técnico especializado y notificaciones sobre el servicio.</li>
                                </ul>
                                <b>Yugonub no vende, alquila ni comparte su información personal con terceros para fines publicitarios.</b>
                            </Paragraph>
                        </section>

                        <section>
                            <Title level={4}>4. Sus Derechos (Acceso y Cancelación)</Title>
                            <Paragraph>
                                Usted tiene derecho en cualquier momento a solicitar la corrección de sus datos o la eliminación definitiva de su cuenta.
                                Para ejercer estos derechos, puede ponerse en contacto con nuestro equipo de soporte a través de los canales oficiales
                                de la plataforma.
                            </Paragraph>
                        </section>

                        <section>
                            <Title level={4}><SafetyCertificateOutlined /> 5. Tratamiento de Datos de Terceros</Title>
                            <Paragraph>
                                Al utilizar <b>YUGONUB</b> para registrar ventas, el usuario (comerciante) actúa como <b>Responsable</b> del tratamiento de los datos de sus clientes finales.
                                Yugonub actúa únicamente como <b>Encargado</b> del tratamiento, proporcionando la infraestructura para el almacenamiento.
                                <ul>
                                    <li>El usuario garantiza que cuenta con la autorización de sus clientes para registrar sus datos en el sistema.</li>
                                    <li>Yugonub no utilizará los datos de los clientes finales del usuario para ningún fin distinto a la prestación del servicio técnico.</li>
                                </ul>
                            </Paragraph>
                        </section>

                        <section>
                            <Title level={4}>6. Transferencia Internacional de Datos</Title>
                            <Paragraph>
                                El usuario acepta que sus datos personales y la información del negocio sean almacenados en servidores de <b>Amazon Web Services (AWS)</b> ubicados fuera del territorio nacional (generalmente en EE. UU.), cumpliendo con estándares internacionales de protección de datos.
                            </Paragraph>
                        </section>

                        <section style={{ background: '#f9f9f9', padding: '20px', borderRadius: '8px' }}>
                            <Text strong>Nota Legal Provisoria:</Text>
                            <Paragraph italic style={{ fontSize: '13px', marginTop: '10px' }}>
                                Este documento es un borrador informativo para los usuarios de Yugonub. Se recomienda la revisión periódica del mismo,
                                ya que puede ser actualizado para cumplir con nuevas normativas legales vigentes.
                            </Paragraph>
                        </section>
                    </Space>
                </Card>
            </Content>

            <Footer style={{ textAlign: 'center', background: 'transparent', padding: '50px 0' }}>
                <Divider />
                <Space split={<Divider type="vertical" />} style={{ marginBottom: '10px' }}>
                    <Link to="/terminos-y-condiciones" style={{ color: '#8c8c8c' }}>Términos y condiciones</Link>
                    <Link to="/politica-privacidad" style={{ color: '#8c8c8c' }}>Política de Privacidad</Link>
                    <Link to="/" style={{ color: '#8c8c8c' }}>Soporte</Link>
                </Space>
                <br />
                <Text type="secondary" style={{ fontSize: '12px' }}>
                    Hecho con ❤️ por el equipo de <span style={{ color: '#22BABB', fontWeight: 'bold' }}>YUGONUB</span> en Colombia.
                </Text>
            </Footer>
        </Layout>
    );
};

export default PoliticaPrivacidad;